export const aciArrowCarrouselLeft = {
    iconName: 'arrow-carrousel-left',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        defs: {
            clipPath: {
                attr: { id: 'clip0_35048_1864' },
                path: {
                    attr: {
                        fill: 'currentColor',
                        transform: 'rotate(90 4.223 11.777)',
                        d: 'M0 0h8.889v7.556H0z',
                    },
                },
            },
        },
        path: {
            attr: {
                'clip-path': 'url(#clip0_35048_1864)',
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M13.432 8.744a.5.5 0 010 .707l-2.771 2.772 2.77 2.771a.5.5 0 01-.706.707l-2.978-2.977a.708.708 0 010-1.002l2.978-2.978a.5.5 0 01.707 0zm-2.978 3.685z',
                fill: 'currentColor',
            },
        },
    },
};
